module.exports = __webpack_public_path__ + "img/exam-center-empty.043df11b.png";